import { Box, LinearProgress, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import * as React from "react";
import { JobStatus } from "../../../Core/Api/Types/job-status";

export interface TableCellWorkflowProgressBarCellProps {
  progress: number;
  status: JobStatus | undefined;
}

const TableCellWorkflowProgressBar: React.FC<TableCellWorkflowProgressBarCellProps> = ({ progress, status }) => {
  const percentage: string = Math.round(progress).toString() + "%";
  let colorText: "default" | "primary" | "success.main" | "info.main" | "error" | "info" = "default";
  let colorBar: "inherit" | "primary" | "success" | "info" | "error" = "inherit";

  switch (status) {
    case undefined:
    case JobStatus.READY:
      colorText = "default";
      colorBar = "inherit";
      break;
    case JobStatus.RUNNING:
      colorText = "primary";
      colorBar = "primary";
      break;
    case JobStatus.COMPLETED:
      colorText = "success.main";
      colorBar = "success";
      break;
    case JobStatus.CANCELLED:
    case JobStatus.ABORTED:
      colorText = "info.main";
      colorBar = "info";
      break;
    case JobStatus.FAILED:
      colorText = "error";
      colorBar = "error";
      break;
  }

  return (
    <>
      {progress ? (
        <Stack>
          <Stack direction="row" alignItems="center">
            <Typography fontWeight={500} mr={1} color={colorText} sx={{ wordBreak: "keep-all" }}>
              {percentage}
            </Typography>
            <Box width="100%" sx={{ minWidth: "80px" }}>
              <LinearProgress sx={{ borderRadius: "2px" }} color={colorBar} variant="determinate" value={progress} />
            </Box>
          </Stack>
        </Stack>
      ) : (
        "-"
      )}
    </>
  );
};

export default TableCellWorkflowProgressBar;
